import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaCheck } from 'react-icons/fa';
import './Pricing.css';

function Pricing() {
  const navigate = useNavigate();

  return (
    <div className="pricing-page">
      <nav className="pricing-navbar">
        <div className="pricing-logo-container" onClick={() => navigate(-1)}>
          <button className="back-btn"><FaArrowLeft /> Back</button>
        </div>
      </nav>

      <div className="pricing-header">
        <h1>Upgrade your Intelligence</h1>
        <p>Unlock the full power of SAMPARK AI with our premium models.</p>
      </div>

      <div className="pricing-cards-container">
        {/* FREE */}
        <div className="pricing-card">
          <div className="pricing-tier">SAMPARK AI Free</div>
          <div className="pricing-price">₹0<span>/month</span></div>
          <p className="pricing-desc">For basic tasks and general inquiries.</p>
          <ul className="pricing-features">
            <li><FaCheck className="check-icon"/> Standard Response Speed</li>
            <li><FaCheck className="check-icon"/> Basic Memory (10 messages)</li>
            <li><FaCheck className="check-icon"/> High/Unlimited RPD Models</li>
            <li><FaCheck className="check-icon"/> Powered by Gemma 4 31B</li>
          </ul>
          <button className="pricing-action-btn current-plan">Current Plan</button>
        </div>

        {/* PLUS */}
        <div className="pricing-card popular">
          <div className="popular-badge">Most Popular</div>
          <div className="pricing-tier">SAMPARK AI Plus</div>
          <div className="pricing-price">₹499<span>/month</span></div>
          <p className="pricing-desc">For professionals needing advanced reasoning.</p>
          <ul className="pricing-features">
            <li><FaCheck className="check-icon"/> Fast Response Speed</li>
            <li><FaCheck className="check-icon"/> Advanced Memory (50 messages)</li>
            <li><FaCheck className="check-icon"/> Mid RPD Models Access</li>
            <li><FaCheck className="check-icon"/> Deep Research Mode</li>
          </ul>
          <button className="pricing-action-btn primary">Upgrade to Plus</button>
        </div>

        {/* PRO */}
        <div className="pricing-card">
          <div className="pricing-tier">SAMPARK AI Pro</div>
          <div className="pricing-price">₹1499<span>/month</span></div>
          <p className="pricing-desc">For power users requiring maximum logic and code generation.</p>
          <ul className="pricing-features">
            <li><FaCheck className="check-icon"/> Ultra-Fast Priority Speed</li>
            <li><FaCheck className="check-icon"/> Infinite Context Memory</li>
            <li><FaCheck className="check-icon"/> Exclusive Low/Min RPD Models</li>
            <li><FaCheck className="check-icon"/> Code Interpreter & Execution</li>
          </ul>
          <button className="pricing-action-btn">Upgrade to Pro</button>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
